<template>
	<div ng-controller="kingdomFealtyCtrl" class="fealtyOverview">
		<div class="contentBox section">
			<div class="contentBoxHeader headerWithArrowEndings glorious">
				<div class="content" translate=""><span>Уровень верности</span></div>
			</div>
			<div class="contentBoxBody">
				<div class="fealtyLevelLabel headerWithArrowEndings kingdomRole fealty">
					<div class="content" translate=""><span>Уровень</span></div>
				</div>
				<div class="fealtyLevel level3" ng-class="{disabled: player.data.lastFealtyProduction < 0}" :content="tooltips[1]" v-tippy="{placement: 'right'}" tooltip-placement="after" tooltip-translate-switch="{
					'Kingdom.Fealty.Tooltip.Unavailable': false,
					'Kingdom.Fealty.Tooltip.MaxLevel': false,
					'Kingdom.Fealty.Tooltip.Vacation': false,
					'Kingdom.Fealty.Tooltip': true
				}">3</div>
				<div class="fealtyProductionContainer" ng-class="{vacation: player.isOnVacation()}">
					<div ng-if="currentFealtyLevel < fealtyBonusLevels[1].length && player.data.lastFealtyProduction >= 0">
						<div class="fealtyProductionPerDay">
							<i class="unit_fealty_small_illu" content="Верность" v-tippy="{placement: 'bottom'}" tooltip-translate="Kingdom.Fealty"></i>
							<span ng-if="currentFealtyProductionPerDay" data="points:2250" translate=""><span>2250 в сутки</span></span>
							<!-- ngIf: !currentFealtyProductionPerDay -->
						</div>
						<div class="nextFealtyLevelCountdown" ng-if="currentFealtyLevel < fealtyBonusLevels[1].length">
							<span translate=""><span>Следующий уровень будет получен в:</span></span>
							<span ng-if="nextFealtyLevelTime" countdown="1729945331.6">01:47:59</span>
							<!-- ngIf: !nextFealtyLevelTime -->
						</div>
						<div class="progressbar" progressbar="" value="51" max-value="220">
							<div class="values"><span class="amount wrapper">51</span>/<span class="capacity">220</span></div>
							<!-- ngIf: ::labelIcon -->
							<div class="progress">
								<!-- ngIf: steps -->
								<div class="bar positive perc " style="z-index: 2; width: 23.2%;"></div>
								<div class="bar additionalBar additionalPerc"></div>
								<div class="marker">
									<div class="markerInner"></div>
								</div>
								<!-- ngIf: ::showCountdown -->
								<!-- ngIf: ::label -->
								<!-- ngIf: ::percTooltip -->
							</div>
						</div>
					</div>
					<!-- ngIf: currentFealtyLevel == fealtyBonusLevels[1].length -->
					<!-- ngIf: player.data.lastFealtyProduction < 0 -->
				</div>
				<div class="symbol_i_medium_wrapper clickable" clickable="openWindow('help', {'pageId': 'Kingdom_Fealty'})">
					<i class="symbol_i_tiny_flat_white"></i>
				</div>
			</div>
		</div>
		<div class="contentBox section fealtyBonuses">
			<div class="contentBoxHeader headerWithArrowEndings glorious">
				<div class="content" translate=""><span>Бонусы</span></div>
			</div>
			<div class="symbol_i_medium_wrapper clickable" clickable="openOverlay('fealtyBonus')" @click="gameModel.society.fealtyBonusShow = true">
				<i class="symbol_i_tiny_flat_white"></i>
			</div>
			<div class="contentBoxBody scrollable" dynamic="" scrollable="" scroll-to-class="fealtyBonus:not(.disabled):not(:has(~ :not(.disabled)))" scroll-to-placement="bottom" scroll-to-offset="80" style="">
				<div class="scrollContentOuterWrapper active" style="width: 588px;">
					<div class="scrollContent" dynamic-height="true" style="width: 608px; overflow-y: auto; max-height: 374px;">
						<div class="scrollContentInnerWrapper" ng-transclude="" style="width: 588px;">
							<div class="fealtyBonus minLevel2" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level3 small">3</div>
								<i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i>
								<div class="bonusDescription" translate="" options="1"><span>Боевой бонус против животных в оазисе</span></div>
								<div class="bonusValue">
									<div class="levelValue">+2%</div>
									<div ng-if="currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index]" class="nextLevelValue">
										<span translate=""><span>Следующий уровень:</span></span> +3%
									</div>
								</div>
								<div class="prestigeBonus" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel2" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level3 small">3</div>
								<i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i>
								<div class="bonusDescription" translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></div>
								<div class="bonusValue">
									<div class="levelValue">+2%</div>
									<div ng-if="currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index]" class="nextLevelValue">
										<span translate=""><span>Следующий уровень:</span></span> +3%
									</div>
								</div>
								<div class="prestigeBonus" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel3" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level3 small">3</div>
								<i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i>
								<div class="bonusDescription" translate="" options="3"><span>Бонус атаки против Разбойники</span></div>
								<div class="bonusValue">
									<div class="levelValue">+1%</div>
									<div ng-if="currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index]" class="nextLevelValue">
										<span translate=""><span>Следующий уровень:</span></span> +2%
									</div>
								</div>
								<div class="prestigeBonus" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel4 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level4 small">4</div>
								<i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i>
								<div class="bonusDescription" translate="" options="4"><span>Стоимость возрождения Героя</span></div>
								<div class="bonusValue">
									<div class="levelValue">-2%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starEmpty_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel5 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level5 small">5</div>
								<i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i>
								<div class="bonusDescription" translate="" options="5"><span>Время возрождения Героя</span></div>
								<div class="bonusValue">
									<div class="levelValue">-3%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel6 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level6 small">6</div>
								<i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i>
								<div class="bonusDescription" translate="" options="6"><span>Грузоподъемность войск</span></div>
								<div class="bonusValue">
									<div class="levelValue">+2%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel7 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level7 small">7</div>
								<i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i>
								<div class="bonusDescription" translate="" options="7"><span>Единицы культуры в сутки в столице</span></div>
								<div class="bonusValue">
									<div class="levelValue">+24</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">+48</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel8 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level8 small">8</div>
								<i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i>
								<div class="bonusDescription" translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></div>
								<div class="bonusValue">
									<div class="levelValue">-3%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel9 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level9 small">9</div>
								<i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i>
								<div class="bonusDescription" translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></div>
								<div class="bonusValue">
									<div class="levelValue">-3.5%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel10 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level10 small">10</div>
								<i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i>
								<div class="bonusDescription" translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></div>
								<div class="bonusValue">
									<div class="levelValue">-4%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starBronze_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel11 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level11 small">11</div>
								<i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i>
								<div class="bonusDescription" translate="" options="11"><span>Время строительства</span></div>
								<div class="bonusValue">
									<div class="levelValue">-1%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel12 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level12 small">12</div>
								<i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i>
								<div class="bonusDescription" translate="" options="12"><span>Стоимость строительства</span></div>
								<div class="bonusValue">
									<div class="levelValue">-0.5%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-0.5%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel13 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level13 small">13</div>
								<i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i>
								<div class="bonusDescription" translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></div>
								<div class="bonusValue">
									<div class="levelValue">-2%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel14 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level14 small">14</div>
								<i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i>
								<div class="bonusDescription" translate="" options="14"><span>Время лечения в Целебном шатре</span></div>
								<div class="bonusValue">
									<div class="levelValue">-1%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel15 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level15 small">15</div>
								<i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i>
								<div class="bonusDescription" translate="" options="15"><span>Сокращение времени обучения в Казарме</span></div>
								<div class="bonusValue">
									<div class="levelValue">-1.5%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starSilver_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel16 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level16 small">16</div>
								<i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i>
								<div class="bonusDescription" translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></div>
								<div class="bonusValue">
									<div class="levelValue">-2%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<div ng-if="!badge">
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starGold_small_illu"></i>
											<i class="prestigeStar prestige_starGold_small_illu"></i>
										</div>
										<!-- ngIf: badge -->
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel17 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level17 small">17</div>
								<i class="bonusIcon kingdom_fealtyBonus17_huge_illu"></i>
								<div class="bonusDescription" translate="" options="17"><span>Бонус нападения</span></div>
								<div class="bonusValue">
									<div class="levelValue">+6%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<!-- ngIf: !badge -->
										<i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_small_illu"></i>
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel18 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level18 small">18</div>
								<i class="bonusIcon kingdom_fealtyBonus18_huge_illu"></i>
								<div class="bonusDescription" translate="" options="18"><span>Бонус защиты</span></div>
								<div class="bonusValue">
									<div class="levelValue">+2%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<!-- ngIf: !badge -->
										<i ng-if="badge" class="prestigeBadge prestige_silverBadge_small_illu"></i>
									</div>
									<div class="prestigeBonusValue">+1%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel19 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level19 small">19</div>
								<i class="bonusIcon kingdom_fealtyBonus19_huge_illu"></i>
								<div class="bonusDescription" translate="" options="19"><span>Ускорение торговцев внутри королевства</span></div>
								<div class="bonusValue">
									<div class="levelValue">-15%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<!-- ngIf: !badge -->
										<i ng-if="badge" class="prestigeBadge prestige_goldBadge_small_illu"></i>
									</div>
									<div class="prestigeBonusValue">-5%</div>
								</div>
							</div>
							<div class="fealtyBonus minLevel20 disabled" ng-repeat="b in fealtyBonusLevels[1] track by $index" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index], unlockLoading: w.params.newLevel == fealtyBonusMinLevel[$index], unlockAnimation: unlockedLevel == fealtyBonusMinLevel[$index]}">
								<div class="fealtyLevel level20 small">20</div>
								<i class="bonusIcon kingdom_fealtyBonus20_huge_illu"></i>
								<div class="bonusDescription" translate="" options="20"><span>Общее потребление войск</span></div>
								<div class="bonusValue">
									<div class="levelValue">-4%</div>
									<!-- ngIf: currentFealtyLevel >= fealtyBonusMinLevel[$index] && currentFealtyLevel < fealtyBonusLevels.length - 1 && fealtyBonusLevels[currentFealtyLevel][$index] != fealtyBonusLevels[currentFealtyLevel + 1][$index] -->
								</div>
								<div class="prestigeBonus disabled" ng-class="{disabled: currentFealtyLevel < fealtyBonusMinLevel[$index] || currentPrestigeLevel < config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl}">
									<div class="innerStars" stars="::prestigeLevels[config.balancing.KingdomConfig.fealtyPrestigeBonuses[$index].minLvl - 1]" size="small">
										<!-- ngIf: !badge -->
										<i ng-if="badge" class="prestigeBadge prestige_diamondBadge_small_illu"></i>
									</div>
									<div class="prestigeBonusValue">-1%</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		tooltips: {
			1: `<span translate="" options="Kingdom.Fealty.Tooltip"><span>Уровень верности повышается при активной игре в выбранном королевстве. Если покинуть королевство, то бонусы будут отключены.</span><br><br><span>При вступлении в королевство уровень верности сбрасывается. Объединение королевств не сбрасывает уровень верности.</span></span>`,
		},
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>